<template>
    <div>
        <FormControl
            label="Display as"
            required
        >
            <div class="space-y-1">
                <RadioInput
                    label="Radio buttons"
                    :value="CustomFieldRadioSelectTypeEnum.Radio"
                    :checked="
                        localSettings?.data?.radioSelectType ===
                        CustomFieldRadioSelectTypeEnum.Radio
                    "
                    :name="`${RequestBodyKeyEnum.App_UpdateService_CustomFields_Settings}[${CustomFieldTypeEnum.RadioSelect}][${CustomFieldSettingsKeysEnum.RadioSelect_Type}]`"
                    required
                />
                <RadioInput
                    label="Dropdown select"
                    :value="CustomFieldRadioSelectTypeEnum.Select"
                    :checked="
                        localSettings?.data?.radioSelectType ===
                        CustomFieldRadioSelectTypeEnum.Select
                    "
                    :name="`${RequestBodyKeyEnum.App_UpdateService_CustomFields_Settings}[${CustomFieldTypeEnum.RadioSelect}][${CustomFieldSettingsKeysEnum.RadioSelect_Type}]`"
                    required
                />
            </div>
        </FormControl>
        <FormControl label="Options">
            <div class="space-y-1">
                <template
                    v-for="(option, index) in localOptions"
                    :key="index"
                >
                    <div class="flex items-center gap-1">
                        <TextInput
                            :name="`${RequestBodyKeyEnum.App_UpdateService_CustomFields_Settings}[${CustomFieldTypeEnum.RadioSelect}][${CustomFieldSettingsKeysEnum.RadioSelect_Options}][]`"
                            :value="option"
                            class="w-full"
                        />
                        <Button
                            @click="handleRemoveOption(index)"
                            iconName="trash"
                            color="light"
                            type="button"
                        ></Button>
                    </div>
                </template>
            </div>
            <div class="flex justify-end mt-2">
                <Button
                    @click="handleAddNewOption()"
                    iconName="plus"
                    color="light"
                    type="button"
                >
                    Add option
                </Button>
            </div>
        </FormControl>
    </div>
</template>

<script setup lang="ts">
    import { ref, type PropType } from 'vue'
    import CustomField from '@/App/CustomField/Entity/CustomField'
    import {
        CustomFieldTypeEnum,
        CustomFieldRadioSelectTypeEnum,
        type CustomFieldSettingsRadioSelectType,
        CustomFieldSettingsKeysEnum,
    } from '@/Shared/AutoGenerated/Main'
    import RadioInput from '@/Shared/Component/Forms/RadioInput.vue'
    import FormControl from '@/Shared/Component/Forms/FormControl.vue'
    import Button from '@/Shared/Component/Button.vue'
    import TextInput from '@/Shared/Component/Forms/TextInput.vue'
    import { RequestBodyKeyEnum } from '@/Shared/AutoGenerated/RequestFieldEnum'

    const props = defineProps({
        customField: {
            type: Object as PropType<CustomField | null>,
            default: null,
        },
    })

    const localSettings: CustomFieldSettingsRadioSelectType | null =
        props.customField?.settings
    const localOptions = ref<string[]>(
        localSettings?.data?.radioSelectOptions ?? [],
    )

    const handleAddNewOption = () => {
        localOptions.value.push('')
    }

    const handleRemoveOption = (index: number) => {
        localOptions.value = localOptions.value.filter(
            (option, optionIndex) => {
                return index !== optionIndex
            },
        )
    }
</script>
